import React, { Fragment, useState, useEffect } from 'react';
import ProductTags from './Product/ProductTags.js';
import SliderContainer from './SliderContainer';
import { useSwipeable } from 'react-swipeable';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const ImageSlider = ({ images, tags, slideCount = 1 }) => {
  const showMore = images && images.length > slideCount;

  return (
    <SliderContainer
      showMore={showMore}
      slideCount={slideCount}
      isImageSlider={true}
      sliderItem={
        <CategorySliderItem images={images} tags={tags} />
      }
    />
  );
};

const CategorySliderItem = ({ images, tags }) => {

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  
  // Preload images so when entering fullscreen they show directly
  // Please change if you know a better solution
  useEffect(() => {
    images.forEach(image => {
      const img = new Image();
      img.src = image.url;
    });
  }, [images]);

  const setChatDisplayValue = (value) => {
    let chatElement = document.getElementById('itx-chat-frame')

    if (!chatElement) return;

    chatElement.style.display = value;
  }

  const onOpen = (currentImageIndex) => {
    document.body.classList.add('disable-scroll');
    setCurrentImageIndex(currentImageIndex);
    setChatDisplayValue('none')
    setIsFullScreen(true);
  };

  const closeFullScreen = () => {
    document.body.classList.remove('disable-scroll');
    setIsFullScreen(false);
    setChatDisplayValue('unset')
  };

  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPreviousImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => goToNextImage(),
    onSwipedRight: () => goToPreviousImage(),
    trackMouse: false
  });

  const Counter = ({ imagesLength }) => (
    <span className="counter">{`${currentImageIndex + 1} av  ${imagesLength}`}</span>
  )

  return (
    <Fragment>
      {images.map((image, index) => (
        <div key={`figure${index}`} onClick={() => onOpen(index)}>
          <div className='image-container'
            dangerouslySetInnerHTML={{ __html: image.image }}
          ></div>
        </div>
      ))}

      {isFullScreen && (
        <div {...handlers} className="fullscreen-view">

          <div className="img-container">
            <img src={images[currentImageIndex].url} alt={`Full screen product ${currentImageIndex + 1}`} />
            <Counter imagesLength={images.length} />
            <span className="desktop arrow right" onClick={goToNextImage}>
              <svg>
                <use href="/ui/images/sprites/a-mobler.svg#right-arrow"></use>
              </svg>
            </span>
            <span className="desktop arrow left" onClick={goToPreviousImage}>
              <svg>
                <use href="/ui/images/sprites/a-mobler.svg#left-arrow"></use>
              </svg>
            </span>
            <span className="desktop close-btn"
              onClick={closeFullScreen}
            >
              <svg>
                <use href="/ui/images/sprites/a-mobler.svg#close-bold"></use>
              </svg>
            </span>
          </div>
          <div className="mobile fullscreen-footer">
            <Counter imagesLength={images.length} />
            <div className="arrows-container">
              <span className="arrow left" onClick={goToPreviousImage}>
                <svg>
                  <use href="/ui/images/sprites/a-mobler.svg#left-arrow"></use>
                </svg>
              </span>
              <span className="arrow right" onClick={goToNextImage}>
                <svg>
                  <use href="/ui/images/sprites/a-mobler.svg#right-arrow"></use>
                </svg>
              </span>
            </div>
            <span className="close-btn"
              onClick={closeFullScreen}
            >
              <svg>
                <use href="/ui/images/sprites/a-mobler.svg#close-bold"></use>
              </svg>
            </span>
          </div>
        </div>
      )}

      <ProductTags tags={tags} />
    </Fragment>
  );
};

export default ImageSlider;
